import { NavLink, useLocation } from "react-router-dom"
import './headerStyle.css'
import { useTranslation } from "react-i18next";

enum DEVIPage {
  Home,
  EVDA,
  EVMC,
  More,
}

const NavBar = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const currentPage = (): DEVIPage | null => {
    if (location.pathname === "/") {
      return DEVIPage.Home;
    }

    if (location.pathname.startsWith("/EVDA")) {
      return DEVIPage.EVDA;
    }

    if (location.pathname.startsWith("/EVMC")) {
      return DEVIPage.EVMC;
    }

    if (location.pathname === "/static/more") {
      return DEVIPage.More;
    }

    return null;
  }

  return(
    <nav role="navigation" aria-label={ t("aria-label--main-menu") || undefined }>
      <ul className="header">
        <li>
          <NavLink 
            end 
            to="/" 
            className="nav-link"
            aria-current={currentPage() === DEVIPage.Home ? "page" : false}
          >
            <div className="nav-item">
              <h2>{t("home")}</h2>
              <hr></hr>
            </div>
          </NavLink>
          </li>
        <li>
          <NavLink
            to="EVDA"
            className="nav-link"
            aria-current={currentPage() === DEVIPage.EVDA ? "page" : false}
          >
            <div className="nav-item">
              <h2>{t("evda_title")}</h2>
              <hr></hr>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="EVMC"
            className="nav-link"
            aria-current={currentPage() === DEVIPage.EVMC ? "page" : false}
          >
            <div className="nav-item">
              <h2>{t("evmc_title")}</h2>
              <hr></hr>
            </div>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="static/more"
            className="nav-link"
            aria-current={currentPage() === DEVIPage.More ? "page" : false}
          >
            <div className="nav-item">
              <h2>{t("more")}</h2>
              <hr></hr>
            </div>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar